import { render, staticRenderFns } from "./gradeItem.vue?vue&type=template&id=5531a09c&scoped=true&"
import script from "./gradeItem.vue?vue&type=script&lang=js&"
export * from "./gradeItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5531a09c",
  null
  
)

export default component.exports